import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatesHelpersService } from '../../../../services/tools/dates-helpers.service';
import { EsquemaInversionService } from '../../../../services/esquema-inversion.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
declare var $;

@Component({
  selector: 'app-incrementar-inversion-modal',
  templateUrl: './incrementar-inversion-modal.component.html',
  styleUrls: ['./incrementar-inversion-modal.component.scss']
})
export class IncrementarInversionModalComponent implements OnInit {

  public isUpdate: boolean = false;
  public incremento_inversion : any = {};
  public errors:any = {};
  public processing: boolean = false;
  public fechaActual : string = "";
  public saldo_disponible: number = 0;

  constructor(
    private datesHelper : DatesHelpersService,
    private helperService: HelpersService,
    public inversionService: EsquemaInversionService,
    public dialogRef: MatDialogRef<IncrementarInversionModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.incremento_inversion = this.inversionService.getDefaultScheduleIncremento();
    let defaultDates = this.datesHelper.getMonthDate();
    this.fechaActual = defaultDates.fechaFin;
    //Agregamos datos por default
    this.saldo_disponible = this.data.saldo;
    this.incremento_inversion.fecha_incremento_inversion = this.fechaActual;
    this.incremento_inversion.idEsquemaInversion = this.data.inversiones.id;
    this.incremento_inversion.idFondeador = this.data.inversiones.idFondeador;

    console.log("Incremento: ", this.incremento_inversion);
    console.log("Data: ",this.data.inversiones);
    
  }

  public close(){
    this.dialogRef.close({incremento:false})
  }

  public accept(){
    
    //Validar
    this.errors = this.inversionService.validateIncremento(this.incremento_inversion);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    
    //Operaciones antes de agregar a la BD
    let total_inversion = parseFloat(this.data.inversiones.total_inversion);
    let monto_incremento = parseFloat(this.incremento_inversion.monto_incremento);
    let tasa_interes = this.data.inversiones.tasa_interes;
    this.incremento_inversion.total_inversion = ( total_inversion + monto_incremento);
    this.incremento_inversion.pago_interes = (this.incremento_inversion.total_inversion * tasa_interes)/100;
    this.agregarIncremento();
  }

  public agregarIncremento(){
    this.inversionService.agregarIncremento(this.incremento_inversion)
     .subscribe(response => {
       const datosIncremento = response.json();

       this.processing = false;
       if (datosIncremento.success) {
         this.helperService.notification('Incremento agregado', 'Se ha agregado exitosamente el incremento de inversión', 'success');
         this.dialogRef.close({incremento:true, datosIncremento: this.incremento_inversion });
         //setTimeout(() => {window.location.reload()},3000);
         
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.close();
     });
  }

  public validarMonto(){
    console.log("Valida monto");
    
    if(this.incremento_inversion.monto_incremento <= this.saldo_disponible){

    }else{
      alert("No cuenta con saldo suficiente para incrementar la inversión");
      this.close();
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/incrementar-inversion-modal/incrementar-inversion-modal.component.ts